/**
 * Utilidad para comprimir imágenes antes de enviarlas a Supabase
 */
export const resizeImage = (base64Str, maxWidth = 1200, maxHeight = 1200) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      
      // Comprimimos a JPEG con calidad al 70% para ahorrar mucho espacio
      resolve(canvas.toDataURL('image/jpeg', 0.7));
    };
  });
};